import {Node, Edge} from 'reactflow';

import {NucleotideType} from 'biojs/BioConstants';
import {ModifiedNucleotide} from 'molbio/monomers/NucleotidesTable';

export interface Position {
  x: number;
  y: number;
}

export interface StructureGraphNodeData {
  entityId: string;
  polymerRef: string;
  width: number;
  height: number;
}

export interface NucleotideStructureGraphNodeData extends StructureGraphNodeData {
  residueIndex: number;
  base: string;
  modifiedNucleotide: ModifiedNucleotide | null;
  nucleotideType: NucleotideType;
  isForward: boolean;
}

export type BaseStructureGraphNode = Node<StructureGraphNodeData>;

export type NucleotideStructureGraphNode = Node<NucleotideStructureGraphNodeData>;

export type StructureGraphNode = BaseStructureGraphNode | NucleotideStructureGraphNode;

export type StructureGraphEdge = Edge;

export interface PolymerStructureGraph {
  nodes: Array<StructureGraphNode>;
  edges: Array<StructureGraphEdge>;
}

export enum NodeType {
  CONJUGATE_NODE = 'CONJUGATE_NODE',
  NUCLEOTIDE_NODE = 'NUCLEOTIDE_NODE',
}

// Keep in sync with ReactFlow edge types
export enum EdgeType {
  SMOOTHSTEP = 'smoothstep',
}

export enum HandleType {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export const ALL_HANDLES = [HandleType.TOP, HandleType.BOTTOM, HandleType.LEFT, HandleType.RIGHT];

// Approximate dimensions of a conjugate chip, to be used for layouting before the chip is rendered
// since its actual dimenions are not yet available
export const DEFAULT_CONJUGATE_NODE_WIDTH = 75;
export const DEFAULT_CONJUGATE_NODE_HEIGHT = 30;

// Actual dimensions of a nucleotide node, to be used for layouting
export const NUCLEOTIDE_NODE_WIDTH = 33.5;
export const NUCLEOTIDE_NODE_HEIGHT = 33.5;

export interface NucleotideAxisData {
  id: string;
  basesLength: number;
  position: Position;
  isForward: boolean;
}

// Keep the following Backend* object in sync with benchling/modbio/complex_polymers/core/polymer_structure_graph.py
export interface BackendStructureGraphNode {
  id: string;
  x: number;
  y: number;
  polymer_ref: string;
  residue_index: number | null;
}

interface BackendStructureGraphEdgeSide {
  id: string;
  handle_type: HandleType;
}

export interface BackendStructureGraphEdge {
  source: BackendStructureGraphEdgeSide;
  target: BackendStructureGraphEdgeSide;
}

export interface BackendPolymerStructureGraph {
  nodes: Array<BackendStructureGraphNode>;
  edges: Array<BackendStructureGraphEdge>;
}
